export var KeyboardKeyEvent;
(function (KeyboardKeyEvent) {
    KeyboardKeyEvent["Down"] = "KeyEventDown";
    KeyboardKeyEvent["Up"] = "KeyEventUp";
})(KeyboardKeyEvent || (KeyboardKeyEvent = {}));
